import axios from "axios";
import store from "../store";
import ls from "local-storage";

import {
  FETCH_ALL_ACCESS_REQUESTS,
  APPROVE_ACCESS_REQUEST,
  REJECT_ACCESS_REQUEST,
  ACCESS_VERIFY,
  FETCH_USERS,
  FETCH_USER,
  CREATE_USER,
  TOGGLE_USER_STATUS,
  UPDATE_USER,
  DELETE_USER,
  GET_CURRENT_USER,
  ATTACH_AVATAR,
  UPDATE_LOGIN_RECORD,
  FETCH_USER_LOGINS,
  ON_APPROVE_ACCESS_REQUEST,
  ON_RECEIVE_ACCESS_REQUEST,
  ON_REJECT_ACCESS_REQUEST,
  interceptor
} from ".";
// import { BASE_URL } from "../utils/helper";

interceptor(axios, store);
export function fetchAllAccessRequests() {
  return {
    type: FETCH_ALL_ACCESS_REQUESTS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/admin/store/get-all-access-requests`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}
export function accessVerify() {
  return {
    type: ACCESS_VERIFY,
    payload: axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/admin/store/login_verify`,
      {},
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id,
          AccessKey: ls.get("access_key")
        }
      }
    )
  };
}
export function approveAccessRequest(accessRequest) {
  return {
    type: APPROVE_ACCESS_REQUEST,
    payload: axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/admin/store/approve_request`,
      { request_id: accessRequest._id },
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      }
    )
  };
}
export function rejectAccessRequest(accessRequest) {
  return {
    type: REJECT_ACCESS_REQUEST,
    payload: axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/admin/store/reject_request`,
      { request_id: accessRequest._id },
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      }
    )
  };
}
export function onApproveAccessRequest(payload) {
  return {
    type: ON_APPROVE_ACCESS_REQUEST,
    payload: payload
  };
}
export function onRejectAccessRequest(payload) {
  return {
    type: ON_REJECT_ACCESS_REQUEST,
    payload: payload
  };
}

export function onReceiveAccessRequest(payload) {
  return {
    type: ON_RECEIVE_ACCESS_REQUEST,
    payload: payload
  };
}
export function createUser(user) {
  return {
    type: CREATE_USER,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/user/`, user, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}
export function createSignupUser(user) {
  return {
    type: CREATE_USER,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/public/user/createSignUp`, user)
  };
}
export function fetchUsers() {
  return {
    type: FETCH_USERS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/user/`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}
export function fetchUser(id) {
  return {
    type: FETCH_USER,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/user/${id}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}
export function getCurrentUser(un) {
  return {
    type: GET_CURRENT_USER,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/user/getUserByUsername/${un}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}
export function toggleUserStatus(u) {
  return {
    type: TOGGLE_USER_STATUS,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/user/changeStatus/${u.id}`, u, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}
export function deleteUserPerm(u) {
  return {
    type: DELETE_USER,
    payload: axios.delete(`${process.env.REACT_APP_API_ENDPOINT}/core/user/${u.id}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}
export function updateUser(id, data) {
  return {
    type: UPDATE_USER,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/user/${id}`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}
export function attachAvatar(id, data) {
  return {
    type: ATTACH_AVATAR,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/user/attachAvatar/${id}`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}
export function updateLoginRecord(data) {
  return {
    type: UPDATE_LOGIN_RECORD,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/login/`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}
export function fetchUserLogins() {
  return {
    type: FETCH_USER_LOGINS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/login/`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}
